import Component from './Component';
// import FavButton from './FavButton';
import { initFavButton } from '../lib/FavButtonsHelper';
import { initAddToTripCardBtnListeners } from '../lib/AddToTripCardBtnHelper';


export default class PreferenceFavourites extends Component {
  load() {
    console.log('PreferenceFavourites');

    initPreferenceFavourites();
    super.load();
  }
}


function initPreferenceFavourites() {
  console.log('initPreferenceFavourites');

  const store = window.localStorage;
  let faves = JSON.parse(store.getItem('favourites')) || [];
  // if (faves.length < 0) {
  //   return;
  // }
  // console.log('faves', faves);

  const productIdsString = faves.toString().replaceAll(',', '-');
  getcardsData(productIdsString);

}


function getcardsData(productIdsString) {
  // console.log('getcardsData()');
  if (!productIdsString || productIdsString.length < 2) {  // return if no productIdsString
    createEmptyMessage();
    return;
  }
  // const url = 'http://dev.southaustralia.localhost/umbraco/api/product/get?id=' + productIdsString;
  // http://localhost:3000
  const url = '/umbraco/api/product/get?id=' + productIdsString;
  // console.log('fetch url:', url);
  fetch(url)
    .then((response) => {
      // console.log('response:', response);
      if (response.status != 200) {
        console.error('fetch error:', response);
      }
      return response.json();
    })
    .then((data) => {
      createDOM(data)
    })
    .catch((error) => console.error(error));  // Catch may occur when errors in the 'createDom()' method.
}


function createEmptyMessage() {
  let fragment = '<div class="faves-grid__empty"><h4>Your favourites are currently empty.</h4></div>';
  let html = $.parseHTML(fragment);

  const target = $('#faves-grid');
  // const target = document.getElementById('faves-grid');
  //append HTML to element
  // target.innerHTML = '';
  target.html(html);
}


function createDOM(data) {

  if (data.length < 1) {
    console.log('no data.Result');
    return;
  }
  // console.log('data.length:', data.length);
  // console.log('BBBdata:', data);
  if (data.length == undefined) {  // Firefox fix. Keep as array even if single element.
    let newData = [];
    newData.push(data);
    data = newData;
  }
  // console.log('CCCdata:', data);


  let fragment = '';
  for (const product of data) {
    // data.forEach(product => {
    // is the product id enough to generate url to product??
    // console.log('product: ', product);
    // Add a fragment when isTripPlannerOn class exists on body element.
    let addToTripFragment = '';
    if (document.querySelector('body.tripplan-on')) {
      addToTripFragment = `
        <button class="product-card__morelink js-addtotrip-btn" productid="${product.id || 'none'}" productname="${product.title}" producttype="Attraction" productlocation="${product.region}">
          <i class="far fa-map-marker-plus"></i>
          Add to my trip
        </button>
      `;
    }

    let frag = '';
    frag = `
      <li class="search-grid__list-item">

        <div class="product-card__wrapper">
          <div class="product-card">
            <div class="product-card__container">

              <article class="product-card__area" productid="${product.id || 'none'}">

                <a href="${product.url || 'none'}" class="product-card__primary">
                  <div class="product-card__image bgimage lazied"
                    data-src="${product.imageUrls[0] || 'none'}&amp;width=576&amp;mode=stretch"
                    data-holdersrc="/media/secfmhxu/placeholder.png"
                    style="background-image: url(&quot;${product.imageUrls[0] || 'none'}&amp;width=576&amp;mode=stretch&quot;), url(&quot;/media/secfmhxu/placeholder.png&quot;);">
                    <div class="product-card__image-info">
                      <div class="product-card__image-info-section">
                        <div class="product-card__category--hover">Attraction</div>
                      </div>
                    </div>
                  </div>

                  <div class="product-card__content">
                    <div class="product-card__header">
                        <div class="product-card__category">Attraction</div>
                    </div>
                    <div class="product-card__region">
                        <span class="product-card__location">${product.region || 'none'}</span>
                    </div>

                    <header class="product-card__main">
                      <h4 class="product-card__title" data-score="2.830528">
                      ${product.title || 'none'}</h4>
                    </header>

                    <div class="product-card__listing-buttons">
                    </div>

                  </div>
                </a>

                <div class="product-card__more">
                  <div class="product-card__fav">
                    <button class="product-card__fav-btn product-card__fav-btn--active" title="favourite">
                      <i class="far fa-heart"></i>
                    </button>
                  </div>
                  ${addToTripFragment}
                </div>

              </article>

            </div>
          </div>
        </div>
      </li>
      `;
    // console.log(frag);
    // console.log('fragment', fragment);
    fragment += frag.trim();
  };
  let html = $.parseHTML(fragment);
  // console.log('html', html);

  const target = $('#faves-grid');
  // const target = document.getElementById('faves-grid');
  //append HTML to element
  // target.innerHTML = '';
  target.html(html);


  // now init FavButton's
  console.log(`init fav button's`);
  // console.log(FavButton);
  // var favButtons = new FavButton();
  // console.log(favButtons);
  initFavButton();

  initAddToTripCardBtnListeners();
}


export { initPreferenceFavourites };
